import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import PlansFeatureItem from './PlansFeatureItem';

export default function ProPlanFeatures(props) {
    return (
        <Stack spacing={2}>
            <Typography variant='h5' fontWeight={500} alignSelf='flex-start'>Funciones principales</Typography>

            <PlansFeatureItem text='Recibir pedidos por Whatsapp' >
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text={<span>Productos <b>Ilimitados</b></span>}>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text={<span>Extras <b>ilimitados</b> por producto</span>}>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Promociones según dias y horarios (Ej. happy hour)'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Mensaje para usuarios según días y horarios'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Horarios para delivery y takeaway'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Ofrecer diferentes medios de entrega'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Ofrecer diferentes medios de pago'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Carga rápida'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Personalizar el pedido'>
                <CheckIcon color='success' />
            </PlansFeatureItem>


            <Typography variant='h5' fontWeight={500} alignSelf='flex-start'>Administra tu menú mas facil</Typography>

            <PlansFeatureItem text='Título, imagen y descripción para productos'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Organizar los productos en caregorias'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Mostrar las calorías de cada producto'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Ofrecer versiones del mismo producto'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text={<span>Poder agregar opciones extra <b>ilimitadas</b> con o sin precio añadido</span>}>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Modificador de precios global'>
                <CheckIcon color='success' />
            </PlansFeatureItem>


            <Typography variant='h5' fontWeight={500} alignSelf='flex-start'>Personaliza tu negocio</Typography>

            <PlansFeatureItem text='Nombre y Descripción de tu negocio'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Logo y portada personalizables'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Incluir redes sociales'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Incluir dirección'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Elije el color de tu menú'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
            <PlansFeatureItem text='Productos destacados'>
                <CheckIcon color='success' />
            </PlansFeatureItem>
        </Stack>
    )
}